var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tt-home"},[_c('HeroCarousel'),(_vm.loading)?_c('div',{staticClass:"tt-home__spinner-wrapper"},[_c('Spinner')],1):_c('div',[_c('Novelties'),_c('ProductsCatalog')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }